// Curated, HEAD-verified (200 OK) legally-free films from 2000 onward.
// This is the ONLY row on the site where a full movie actually plays end
// to end (main catalogue rows show TMDB metadata + trailer only — modern
// licensed content can't be streamed for free).
//
// The universe of legally-free 2000+ features is small (most big titles
// are still under copyright); the picks below are Creative Commons open
// movies (Blender Foundation, Nina Paley's Sita Sings the Blues,
// Star Wreck) plus a couple of freely-distributed indie features.

const PUBLIC_DOMAIN_MOVIES = [
  {
    id: 'pd_sita_sings_the_blues',
    media_type: 'movie',
    title: 'Sita Sings the Blues',
    overview:
      "Nina Paley's dazzling 2008 animated musical retelling of the Ramayana, set to 1920s jazz recordings by Annette Hanshaw. Released under Creative Commons — legal to stream and share.",
    backdrop_path: 'https://archive.org/services/img/Sita_Sings_the_Blues',
    poster_path: 'https://archive.org/services/img/Sita_Sings_the_Blues',
    stream_url:
      'https://archive.org/download/Sita_Sings_the_Blues/Sita_Sings_the_Blues_DVD_NTSC1.mp4',
    release_date: '2008-02-11',
    vote_average: 7.9,
    runtime: 82,
    genres_label: 'Animation · Musical',
  },
  {
    id: 'pd_star_wreck',
    media_type: 'movie',
    title: 'Star Wreck: In the Pirkining',
    overview:
      "A Finnish CGI sci-fi parody of Star Trek and Babylon 5. Fan-funded, Creative Commons, and the most-watched Finnish film ever made when it launched in 2005.",
    backdrop_path: 'https://archive.org/services/img/StarWreckInThePirkining',
    poster_path: 'https://archive.org/services/img/StarWreckInThePirkining',
    stream_url: 'https://archive.org/download/StarWreckInThePirkining/StarWreck.mp4',
    release_date: '2005-08-20',
    vote_average: 7.2,
    runtime: 103,
    genres_label: 'Sci-Fi · Comedy',
  },
  {
    id: 'pd_megan_is_missing',
    media_type: 'movie',
    title: 'Megan Is Missing',
    overview:
      "Michael Goi's 2011 found-footage cautionary thriller about two teenage girls who fall victim to an online predator. Distributed freely by the director for public awareness.",
    backdrop_path: 'https://archive.org/services/img/megan-is-missing',
    poster_path: 'https://archive.org/services/img/megan-is-missing',
    stream_url: 'https://archive.org/download/megan-is-missing/Megan%20Is%20Missing.mp4',
    release_date: '2011-05-03',
    vote_average: 4.6,
    runtime: 85,
    genres_label: 'Horror · Thriller',
  },
  {
    id: 'pd_cosmos_laundromat',
    media_type: 'movie',
    title: 'Cosmos Laundromat: First Cycle',
    overview:
      "Blender Foundation's 2015 open movie: a suicidal sheep on a barren island meets an eccentric salesman offering him alternate lives. Stunning modern CGI, Creative Commons.",
    backdrop_path: 'https://archive.org/services/img/CosmosLaundromatFirstCycle',
    poster_path: 'https://archive.org/services/img/CosmosLaundromatFirstCycle',
    stream_url:
      'https://archive.org/download/CosmosLaundromatFirstCycle/Cosmos%20Laundromat%20-%20First%20Cycle%20%281080p%29.mp4',
    release_date: '2015-08-10',
    vote_average: 7.1,
    runtime: 12,
    genres_label: 'Animation · Sci-Fi',
  },
  {
    id: 'pd_spring',
    media_type: 'movie',
    title: 'Spring',
    overview:
      "Blender Foundation's 2019 animated short: a girl and her dog fight to save the cycle of seasons in a beautifully hand-drawn CGI world.",
    backdrop_path: 'https://archive.org/services/img/spring_blenderopenmovie',
    poster_path: 'https://archive.org/services/img/spring_blenderopenmovie',
    stream_url:
      'https://archive.org/download/spring_blenderopenmovie/Spring%20-%20Blender%20Open%20Movie%20-%20YouTube.mp4',
    release_date: '2019-04-04',
    vote_average: 7.6,
    runtime: 8,
    genres_label: 'Animation · Fantasy',
  },
  {
    id: 'pd_sintel',
    media_type: 'movie',
    title: 'Sintel',
    overview:
      "Blender Foundation's 2010 CGI fantasy: a lonely young woman treks across a harsh world to reunite with her lost dragon companion. Creative Commons — free to watch.",
    backdrop_path: 'https://archive.org/services/img/Sintel',
    poster_path: 'https://archive.org/services/img/Sintel',
    stream_url: 'https://archive.org/download/Sintel/sintel-2048-stereo_512kb.mp4',
    release_date: '2010-09-30',
    vote_average: 7.4,
    runtime: 15,
    genres_label: 'Animation · Fantasy',
  },
  {
    id: 'pd_tears_of_steel',
    media_type: 'movie',
    title: 'Tears of Steel',
    overview:
      "Blender's 2012 live-action + CGI sci-fi short. A group of scientists must persuade a former lover to help save a future Amsterdam from a robot invasion.",
    backdrop_path: 'https://archive.org/services/img/Tears-of-Steel',
    poster_path: 'https://archive.org/services/img/Tears-of-Steel',
    stream_url: 'https://archive.org/download/Tears-of-Steel/tears_of_steel_1080p.mp4',
    release_date: '2012-09-26',
    vote_average: 6.7,
    runtime: 12,
    genres_label: 'Sci-Fi · Live Action',
  },
  {
    id: 'pd_big_buck_bunny',
    media_type: 'movie',
    title: 'Big Buck Bunny',
    overview:
      "Blender's 2008 CGI classic: a jolly forest bunny gets even with three bullying rodents. Colourful, kid-friendly, Creative Commons.",
    backdrop_path: 'https://archive.org/services/img/BigBuckBunny_124',
    poster_path: 'https://archive.org/services/img/BigBuckBunny_124',
    stream_url:
      'https://archive.org/download/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4',
    release_date: '2008-05-20',
    vote_average: 7.4,
    runtime: 10,
    genres_label: 'Animation · Family',
  },
];

export default PUBLIC_DOMAIN_MOVIES;
